"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@mui/material/utils");
var Icon = function (props) { return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "currentColor", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fillRule: "evenodd", d: "M8.518 18.18a5.357 5.357 0 0 0 3.732 1.499c1.41 0 2.752-.546 3.732-1.499a4.95 4.95 0 0 0 1.518-3.55c0-.724-.298-1.774-.933-3.085-.615-1.27-1.455-2.604-2.326-3.84-.7-.99-1.401-1.894-1.991-2.621-.59.727-1.292 1.63-1.99 2.621-.872 1.236-1.712 2.57-2.327 3.84C7.298 12.856 7 13.906 7 14.63c0 1.32.54 2.598 1.518 3.55zm2.418-14.65C8.847 6.07 5 11.207 5 14.63c0 1.87.764 3.662 2.123 4.984a7.358 7.358 0 0 0 5.127 2.065 7.358 7.358 0 0 0 5.127-2.065 6.95 6.95 0 0 0 2.123-4.985c0-3.423-3.847-8.56-5.936-11.098C12.784 2.585 12.25 2 12.25 2s-.535.585-1.314 1.53z", clipRule: "evenodd" }))); };
var SvgWater = (0, utils_1.createSvgIcon)(React.createElement(Icon, null), 'SvgWater');
exports.default = SvgWater;
